export const PRIMARY_ORANGE = '#E55C1A'; 
export const COLORS = [PRIMARY_ORANGE, '#10b981', '#3b82f6', '#8b5cf6', '#ec4899', '#f59e0b'];

export const LIGHT_MODE_COLORS = {
    BG_MAIN: '#eef2f7',
    BG_CARD: '#ffffff',
    BG_CARD_SOLID: '#ffffff',
    BG_SOFT: '#f3f6fa',
    BORDER_CARD: '#cbd5e1',
    BORDER_SOFT: '#dbe3ec',
    TEXT_PRIMARY: '#0f172a',
    TEXT_SECONDARY: '#334155',
    TEXT_MUTED: '#475569',
    TEXT_SUBTLE: '#64748b',
    ACCENT_PRIMARY: '#d94b0b',
    ACCENT_PRIMARY_HOVER: '#b93808',
    ACCENT_SOFT: '#fff4ed',
    ACCENT_BORDER: '#fdba74',
    CHART_GRID: '#cbd5e1',
    CHART_AXIS: '#475569'
};

export const DARK_MODE_COLORS = {
    BG_MAIN: '#1A1A1A',
    BG_CARD: '#292929',
    BORDER_CARD: '#404040',
    TEXT_PRIMARY: '#FFFFFF',
    TEXT_SECONDARY: '#E0E0E0',
    ACCENT_PRIMARY: '#E55C1A',
    ACCENT_SECONDARY: '#ff8d4a',
    CHART_GRID: '#404040',
    CHART_AXIS: '#E0E0E0',
    GROWTH_POSITIVE: '#10b981',
    GROWTH_NEGATIVE: '#ef4444',
    BLUE_ACCENT: '#3b82f6'
};
